// global process
import { initWidget } from './widget';
import endpoints from './widget/define/endpoints';

// loadable imports
import AddToWishList from './widget/component/AddToWishList';
import BookingForm from './widget/component/BookingForm';
import NavigationMenu from './widget/component/NavigationMenu';
import OrderList from './widget/component/OrderList';
import FilterResults, {
  FilterResultsBeta,
} from './widget/component/FilterResults';
import ExtraServices from './widget/component/ExtraServices';
import NewsLetterForm from './widget/component/NewsLetterForm';
import WishList from './widget/component/WishList';
import ContactForm from './widget/component/ContactForm';
import RelatedListings from './widget/component/RelatedListings';
import SearchForm from './widget/component/SearchForm/SearchForm';
import Reviews from './widget/component/Reviews';
import Share from './widget/component/Share';
import Dedication from './widget/component/Dedication';
import Profile from './widget/component/Profile';
import ThankYou from './widget/component/ThankYou';
import {
  AuthenticationCheckout,
  OrderRecapCheckout,
} from './widget/component/Checkout';
import Tooltip from './widget/component/Tooltip';
import TrustpilotWebhook from './widget/component/Trustpilot/TrustpilotWebhook';

// standard imports
import AddToHistory from './widget/component/AddToHistory';
import HistoryList from './widget/component/HistoryList';
import { ModalLikeListing } from './widget/component/modals';
import { ModalPartnerSignup } from './widget/component/modals';
import { ModalCustomerSignup } from './widget/component/modals';
import { ModalAffiliateContactForm } from './widget/component/modals';
// import SearchResultsWidget from './widget/component/SearchResults';
import { UserBanner as WelfareUserBanner } from './widget/component/WelfareComponents/UserBanner';
import ModalFilters from './widget/component/modals/ModalFiltersResults/ModalFilters';
import Avatar from './widget/component/Avatar/Avatar';
import Slideshow from './widget/component/Slideshow/Slideshow';
import { SmartFilterResults } from './widget/component/FilterResults';
import SmartNavigationMenu from './widget/component/NavigationMenu/SmartNavigationMenu';
import SmartSearchForm from './widget/component/SearchForm/SmartSearchForm';
import SmartSearchTermsAutocomplete from './widget/component/SearchForm/SmartSearchTermsAutocomplete';
import B2BForm from './widget/component/B2BForm/B2BForm';
import XmasContestForm from './widget/component/XmasContestForm/XmasContestForm';

import B2BInfo from './widget/component/modals/B2BInfo';
import CoverSwiper from './widget/component/CoverSwiper/CoverSwiper';
import ManageOrder from './widget/component/ManageOrder/ManageOrder';
import FaqSearch from './widget/component/ManageOrder/FaqSearch';

const initGeneralWidget = function () {
  // initialize widgets and sections
  const props = {
    endpoints,
  };

  initWidget('modal-affiliate-contact-form', ModalAffiliateContactForm, props);
  initWidget('modal-partner-signup', ModalPartnerSignup, props);
  initWidget('modal-customer-signup', ModalCustomerSignup, props);
  initWidget('modal-like-listing', ModalLikeListing, props);
  initWidget('add-to-history', AddToHistory, props);
  initWidget('add-to-wish-list', AddToWishList, props);
  initWidget('booking-form', BookingForm, props);
  initWidget('history-list', HistoryList, props);
  initWidget('navigation-menu', NavigationMenu, props);
  initWidget('order-list', OrderList, props);
  initWidget('search-form', SearchForm, props);
  // initWidget('search-results', SearchResultsWidget, props);
  initWidget('extra-services', ExtraServices, props);
  initWidget('filter-results', FilterResults, props);
  initWidget('wish-list', WishList, props);
  initWidget('contact-form', ContactForm, props);
  initWidget('newsletter', NewsLetterForm, props);
  initWidget('share', Share, props);
  initWidget('reviews', Reviews, props);
  initWidget('related-listings', RelatedListings, props);
  initWidget('tooltip', Tooltip, props);
  initWidget('dedication', Dedication, props);
  initWidget('order-recap-checkout', OrderRecapCheckout, props);
  initWidget('authentication-checkout', AuthenticationCheckout, props);
  initWidget('thank-you', ThankYou, props);
  initWidget('profile', Profile, props);
  initWidget('manage-order', ManageOrder, props);
  initWidget('faq-search', FaqSearch, props);
  initWidget('welfare-user-banner', WelfareUserBanner, props);
  initWidget('trustpilot-webhook', TrustpilotWebhook, props);
  initWidget('modal-filters', ModalFilters, props);
  initWidget('avatar', Avatar, props);
  initWidget('b2b-form', B2BForm, props);
  initWidget('xmas-contest-form', XmasContestForm, props);
  initWidget('b2b-info', B2BInfo, props);
  initWidget('slide-show', Slideshow, props);
  initWidget('cover-swiper', CoverSwiper, props);
  // smart search experiment
  initWidget('smart-filter-results', SmartFilterResults, props);
  initWidget('smart-navigation-menu', SmartNavigationMenu, props);
  initWidget('smart-search-form', SmartSearchForm, props);
  initWidget(
    'smart-search-terms-autocomplete',
    SmartSearchTermsAutocomplete,
    props
  );
  // end smart search experiment
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initGeneralWidget.bind(this));
} else {
  initGeneralWidget();
}
